import { useEffect } from 'react';
import { useTenant } from '../app';
import { Kicker, Link } from '../components';

/**
 * Platzhalter für den Kauf (Konzept 4.6, 7.1): Hier kommt der Weg zu Stripe hin – Pflicht-Häkchen zum
 * Widerruf, dann die Bezahlseite. Bis Stripe angebunden ist, sagt die Seite ehrlich, was fehlt.
 */
export function CheckoutPage({ productSlug }: { productSlug: string }) {
  const tenant = useTenant();
  useEffect(() => {
    document.title = `Kaufen – ${tenant.name}`;
  }, [tenant.name]);
  return (
    <main className="page page--narrow">
      <Kicker>Kaufen</Kicker>
      <h1>Die Bezahlung wird gerade eingerichtet</h1>
      <div className="card">
        <p>
          Dieses Angebot (<code>{productSlug}</code>) kann noch nicht online gekauft werden. Sobald die Zahlung über Stripe angebunden ist, geht es hier direkt zur Bezahlseite – mit Karte, Apple Pay, Google Pay, SEPA, Klarna oder PayPal.
        </p>
        <p className="muted small">Du hast schon Zugang? Dann melde dich einfach an.</p>
        <p style={{ marginTop: 20 }}>
          <Link href="/anmelden" className="button">
            Anmelden
          </Link>{' '}
          <Link href="/" className="button button--secondary">
            Zur Bibliothek
          </Link>
        </p>
      </div>
    </main>
  );
}
